/**
 * Loads human-agent QA aggregates via reporting leaderboard.
 */

import { fetchLeaderboard } from "@/api/homeReportingApi";

const SCOPE = "HumanAgentQaReportingService";

export class HumanAgentQaReportingService {
  /**
   * @param {{ startDate: string, endDate: string }} range
   * @param {AbortSignal} [signal]
   */
  async load(range, signal) {
    const init = signal ? { signal } : {};
    const res = await fetchLeaderboard(range, init);
    const lb = res?.leaderboard;
    return Array.isArray(lb) ? lb : [];
  }

  /**
   * @param {Error} err
   */
  logError(err) {
    if (typeof console !== "undefined" && console.error) {
      console.error(`[${SCOPE}]`, { message: err?.message ?? String(err) });
    }
  }
}

export const humanAgentQaReportingService = new HumanAgentQaReportingService();
